import { SessionSlot } from 'model/NewMultipleBooking';
import { Moment } from 'moment-timezone';

export interface SessionDateSlot {
    date: Moment;
    dateEnd: Moment;
    // Set when the slot comes from a picked session, which carries its own staff and link.
    staffId?: number;
    serviceSessionId?: number | null;
}

// One slot per session picked on `day` (YYYY-MM-DD in `tz`), in time order. Empty when the
// date has no pick, so the caller books its typed time instead.
export const pickedSessionSlotsOnDay = (
    sessionSlots: Array<SessionSlot> | undefined,
    day: string,
    durationInMinutes: number,
    tz: string
): Array<SessionDateSlot> =>
    (sessionSlots ?? [])
        .filter(slot => slot.from.clone().tz(tz).format('YYYY-MM-DD') === day)
        .sort((a, b) => a.from.valueOf() - b.from.valueOf())
        .map(slot => {
            const date = slot.from.clone().tz(tz);

            return {
                date,
                dateEnd: date.clone().add(durationInMinutes, 'minutes'),
                staffId: slot.staffId,
                serviceSessionId: slot.serviceSessionId
            };
        });
